import e from "../_virtual/_plugin-vue_export-helper.js";
import t from "./SchemaProperty.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                   */
//#region src/schema/SchemaProperty.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-00f22f7c"]]);
//#endregion
export { n as default };

//# sourceMappingURL=SchemaProperty.vue.js.map